
(function () {
  'use strict';

  var config = window.freeGiftConfig;

  if (!config || !config.enabled) return;

  var CHECK_DELAY = 100;
  var busy = false;
  var pending = false;
  var timer = null;
  var observer = null;

  /*
   * GET CURRENT SHOPIFY CART
   */
  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to retrieve Shopify cart.');
      }

      return response.json();
    });
  }

  /*
   * SHOPIFY CART CHANGE REQUEST
   */
  function cartRequest(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error(
            error.description || error.message || 'Cart update failed.'
          );
        });
      }

      return response.json();
    });
  }

  /*
   * GET PROMOTION ELEMENT
   */
  function getPromotion() {
    return document.querySelector('[data-cart-free-gift]');
  }

  /*
   * GET PROMOTION SETTINGS FROM LIQUID
   */
  function getPromotionSettings() {
    var element = getPromotion();

    if (!element) return null;

    return {
      element: element,
      threshold: Number(element.dataset.freeGiftLimit),
      giftProductId: String(element.dataset.freeGiftProductId),
      variantId: Number(element.dataset.freeGiftVariantId),
      messageTemplate: element.dataset.freeGiftMessageTemplate || '',
      successMessage: element.dataset.freeGiftSuccessMessage || '',
      collectionTitle: element.dataset.freeGiftCollectionTitle || '',
      collectionUrl: element.dataset.freeGiftCollectionUrl || '',
      giftTitle: element.dataset.freeGiftTitle || ''
    };
  }

  /*
   * CHECK COLLECTION MEMBERSHIP
   */
  function productQualifies(item, giftProductId) {
    if (!item || !item.product_id) return false;

    if (String(item.product_id) === String(giftProductId)) {
      return false;
    }

    var qualifyingProducts = config.qualifyingProductIds || {};

    return qualifyingProducts[String(item.product_id)] === true;
  }

  /*
   * CALCULATE QUALIFYING SUBTOTAL
   */
  function getQualifyingSubtotal(cart, settings) {
    var subtotal = 0;

    cart.items.forEach(function (item) {
      if (productQualifies(item, settings.giftProductId)) {
        subtotal += Number(item.final_line_price || 0);
      }
    });

    return subtotal;
  }

  /*
   * FIND FREE GIFT IN CART
   */
  function findGift(cart, settings) {
    return cart.items.find(function (item) {
      return String(item.product_id) === settings.giftProductId;
    }) || null;
  }

  /*
   * FORMAT MONEY
   */
  function formatMoney(cents) {
    var theme = window.theme || {};
    var currency = theme.currencyCode || 'USD';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || undefined,
        {
          style: 'currency',
          currency: currency,
          currencyDisplay: theme.settings &&
            theme.settings.currency_code_enable ? 'code' : 'symbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      ).format(cents / 100);

    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /*
   * ESCAPE HTML VALUES
   */
  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  /*
   * BUILD PROGRESS MESSAGE
   */
  function buildProgressMessage(settings, remaining) {
    var amount = '<strong>' + escapeHTML(formatMoney(remaining)) + '</strong>';

    var collectionLink =
      '<a href="' + escapeHTML(settings.collectionUrl) +
      '" style="text-decoration: underline; text-underline-offset: 3px;">' +
      escapeHTML(settings.collectionTitle) +
      '</a>';

    var giftTitle = '<strong>' +
      escapeHTML(settings.giftTitle) +
      '</strong>';

    return settings.messageTemplate
      .split('||amount||').join(amount)
      .split('||collection title||').join(collectionLink)
      .split('||free gift title||').join(giftTitle);
  }

  /*
   * UPDATE PROMOTION DISPLAY
   */
  function updatePromotion(settings, qualifyingSubtotal) {
    var element = settings.element;

    if (!element || !element.isConnected) return;

    var qualifies = qualifyingSubtotal >= settings.threshold;

    var remaining = Math.max(
      0,
      settings.threshold - qualifyingSubtotal
    );

    var percentage = settings.threshold > 0
      ? Math.min(
          100,
          (qualifyingSubtotal / settings.threshold) * 100
        )
      : 100;

    element.dataset.freeGiftQualified = qualifies ? 'true' : 'false';

    var message = element.querySelector('.cart-free-gift__message');

    if (message) {
      if (qualifies) {
        message.classList.add('cart-free-gift__message--success');
        message.innerHTML = settings.successMessage;

      } else {
        message.classList.remove('cart-free-gift__message--success');
        message.innerHTML = buildProgressMessage(settings, remaining);
      }
    }

    var progressBar = element.querySelector(
      '.cart-free-gift__progress-bar'
    );

    if (progressBar) {
      progressBar.style.width = percentage + '%';

      progressBar.setAttribute(
        'aria-valuenow',
        String(Math.round(percentage))
      );
    }
  }

  /*
   * ADD FREE GIFT
   */
  function addGift(settings) {
    if (!settings.variantId) {
      return Promise.reject(
        new Error('Free gift variant ID is missing.')
      );
    }

    return cartRequest('/cart/add.js', {
      items: [{
        id: settings.variantId,
        quantity: 1
      }]
    });
  }

  /*
   * REMOVE FREE GIFT
   */
  function removeGift(gift) {
    return cartRequest('/cart/change.js', {
      id: gift.key,
      quantity: 0
    });
  }

  /*
   * KEEP GIFT QUANTITY AT ONE
   */
  function correctGiftQuantity(gift) {
    return cartRequest('/cart/change.js', {
      id: gift.key,
      quantity: 1
    });
  }

  /*
   * REFRESH STORY CART DRAWER
   *
   * IMPORTANT:
   * Story expects the complete Shopify cart object
   * inside the theme:cart:change event.
   *
   * theme:cart:reload then calls Story's loadHTML()
   * and loadForm() methods to rebuild the drawer.
   */
  function notifyTheme(cart) {
    document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
        detail: {
          cart: cart
        },
        bubbles: true
      })
    );

    document.dispatchEvent(
      new CustomEvent('theme:cart:reload', {
        bubbles: true
      })
    );
  }

  /*
   * PROCESS ONE CART CHECK
   */
  async function processCheck() {
    var settings = getPromotionSettings();

    if (!settings || !settings.threshold) return;

    var cart = await getCart();

    var subtotal = getQualifyingSubtotal(cart, settings);

    var qualifies = subtotal >= settings.threshold;

    var gift = findGift(cart, settings);

    updatePromotion(settings, subtotal);

    /*
     * QUALIFIED BUT GIFT IS MISSING
     */
    if (qualifies && !gift) {
      await addGift(settings);

      /*
       * Retrieve the COMPLETE updated cart.
       * /cart/add.js alone does not return the
       * complete cart object Story requires.
       */
      cart = await getCart();

      subtotal = getQualifyingSubtotal(cart, settings);

      updatePromotion(settings, subtotal);

      /*
       * Pass fresh cart data to Story and refresh.
       */
      notifyTheme(cart);

      return;
    }

    /*
     * NOT QUALIFIED BUT GIFT EXISTS
     */
    if (!qualifies && gift) {
      /*
       * /cart/change.js returns the complete cart.
       */
      cart = await removeGift(gift);

      subtotal = getQualifyingSubtotal(cart, settings);

      updatePromotion(settings, subtotal);

      notifyTheme(cart);

      return;
    }

    /*
     * QUALIFIED BUT GIFT QUANTITY IS WRONG
     */
    if (qualifies && gift && Number(gift.quantity) > 1) {
      cart = await correctGiftQuantity(gift);

      subtotal = getQualifyingSubtotal(cart, settings);

      updatePromotion(settings, subtotal);

      notifyTheme(cart);

      return;
    }
  }

  /*
   * QUEUED CHECK SYSTEM
   */
  async function runChecks() {
    if (busy) {
      pending = true;
      return;
    }

    busy = true;

    try {
      do {
        pending = false;

        await processCheck();

      } while (pending);

    } catch (error) {
      console.error('Free Gift:', error);

    } finally {
      busy = false;

      if (pending) {
        requestCheck();
      }
    }
  }

  /*
   * REQUEST A CART CHECK
   */
  function requestCheck() {
    pending = true;

    clearTimeout(timer);

    timer = setTimeout(function () {
      runChecks();
    }, CHECK_DELAY);
  }

  /*
   * DETECT STORY CART DRAWER CHANGES
   */
  function isCartChange(mutation) {
    var target = mutation.target;

    if (target.nodeType === 3) {
      target = target.parentElement;
    }

    if (!target || !target.closest) return false;

    if (target.closest('[data-cart-free-gift]')) {
      return false;
    }

    return Boolean(target.closest('#drawer-cart'));
  }

  /*
   * WATCH EXISTING CART DRAWER
   */
  function startObserver() {
    if (!document.body || observer) return;

    observer = new MutationObserver(function (mutations) {
      var cartChanged = mutations.some(isCartChange);

      if (cartChanged) {
        requestCheck();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /*
   * INITIALIZE
   */
  function initialize() {
    startObserver();

    requestCheck();

    document.addEventListener('theme:cart:change', requestCheck);

    document.addEventListener('theme:cart:reload', requestCheck);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();
